import axios from "axios";
import { HTTPURL } from "./constants/matcher";

export default axios.create({
  baseURL: HTTPURL,
  headers: {
    "Content-type": "application/json"   
  }
});
